import { render, staticRenderFns } from "./save-location-dialog.component.vue?vue&type=template&id=f3036548"
import script from "./save-location-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-location-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports